import { ref, watch, computed } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { getExpenses } from '@/composables/expenseService'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useExpensesList() {
  // Use toast
  const toast = useToast()

  const refExpenseListTable = ref(null)

  // Table Handlers
  const tableColumns = ref([
    { key: 'id', label: '#', sortable: true },
    { key: 'customer_billing_full_name', label: 'Proveedor', sortable: true },
    { key: 'amount', label: i18n.t('Amount'), sortable: true },
    { key: 'dates', label: 'Fechas', sortable: true },
    { key: 'payment_method', label: i18n.t('Método de pago'), sortable: true },
    { key: 'paid', label: i18n.t('Paid'), sortable: true },
    { key: 'actions', label: i18n.t('Actions') },
  ])
  const perPage = ref(10)
  const totalExpenses = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const typeFilter = ref(null)
  const paymentMethodFilter = ref(null)
  const groupFilter=ref(null)
  const startDateFilter=ref(null)
  const endDateFilter=ref(null)
  const accountFilter=ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refExpenseListTable.value ? refExpenseListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalExpenses.value,
    }
  })

  const refetchData = () => {
    refExpenseListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter, typeFilter, paymentMethodFilter, startDateFilter, endDateFilter, groupFilter, accountFilter], () => {

    refetchData()
  })

  // old
  // const fetchExpenses = (ctx, callback) => {
  //   store
  //     .dispatch('expenses/fetchExpenses', {
  //       q: searchQuery.value,
  //       perPage: perPage.value,
  //       page: currentPage.value,
  //       sortBy: sortBy.value,
  //       sortDesc: isSortDirDesc.value,
  //       status: statusFilter.value,
  //       type: typeFilter.value,
  //       paymentMethod: paymentMethodFilter.value,
  //       group: groupFilter.value,
  //       start_date: startDateFilter.value,
  //       end_date: endDateFilter.value,
  //       account: accountFilter.value
  //     })
  //     .then(response => {
  //       const { expenses, total } = response.data

  //       callback(expenses)
  //       totalExpenses.value = total
  //     })
  //     .catch(() => {
  //       toast({
  //         component: ToastificationContent,
  //         props: {
  //           title: "Error fetching Expense list",
  //           icon: 'AlertTriangleIcon',
  //           variant: 'danger',
  //         },
  //       })
  //     })
  // }

  const fetchExpenses = async function () {
    let response = await getExpenses({ 
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      type: typeFilter.value,
      paymentMethod: paymentMethodFilter.value,
      group: groupFilter.value,
      start_date: startDateFilter.value,
      end_date: endDateFilter.value,
      account: accountFilter.value
    })

    const { expenses, total } = response.data
    totalExpenses.value = total
    
    return expenses
  }

  const isPartialPaid = function(amount, payments){
    if((payments < 0 && payments > amount) || (payments > 0 && payments < amount)) return {value: true , owe: amount-payments}
    return {value: false}
  }
  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveExpenseStatusVariantAndIcon = function(amount, total_payments) {
    if (amount == total_payments) return { variant: 'success', icon: 'CheckCircleIcon', label: 'Pagado' }
    if (total_payments == 0) return { variant: 'danger', icon: 'InfoIcon', label: 'No pagado' }
    if (total_payments > 0 && total_payments < amount) return { variant: 'warning', icon: 'ShuffleIcon', label: 'Pagado parcialmente' }
    if (total_payments < 0 && total_payments > amount) return { variant: 'warning', icon: 'ShuffleIcon', label: 'Pagado parcialmente' }

    return { variant: 'secondary', icon: 'XIcon' }
  }

  const resolveClientAvatarVariant = function(amount, total_payments) {
    if (amount == total_payments) return 'success'
    if (total_payments == 0) return 'danger'
    if (total_payments > 0 && total_payments < amount) return 'warning'
    
    return 'primary'
  }

  return {
    fetchExpenses,
    isPartialPaid,
    tableColumns,
    perPage,
    currentPage,
    totalExpenses,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refExpenseListTable,

    statusFilter,
    typeFilter,
    paymentMethodFilter,
    startDateFilter,
    endDateFilter,
    groupFilter,
    accountFilter,

    resolveExpenseStatusVariantAndIcon,
    resolveClientAvatarVariant,

    refetchData,
  }
}
